"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _recharts = require("recharts");

var _providers = require("../../toolkit/providers");

var _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Line = (0, _mobxReact.observer)(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Line, _Component);

  var _super = _createSuper(Line);

  function Line() {
    (0, _classCallCheck2["default"])(this, Line);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Line, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_recharts.Line, this.props);
    }
  }]);
  return Line;
}(_react.Component), _class2.propDoc = {
  yAxisId: {
    required: true,
    type: "string",
    description: "The id of y-axis which is corresponding to the data."
  },
  dataKey: {
    required: true,
    type: "string",
    description: "The key or getter of a group of data which should be" + "unique in a LineChart."
  },
  stroke: {
    required: true,
    type: "string",
    description: "colour of line"
  },
  strokeWidth: {
    required: true,
    type: "number",
    description: "thickness of the line"
  },
  strokeDasharray: {
    required: false,
    type: "string",
    description: "line becomes dashed (example value \"2 2\")"
  },
  type: {
    required: false,
    type: "string",
    description: "line type (see source code for details/examples)"
  },
  name: {
    required: false,
    type: "string | number",
    description: "The name of data. This option will be used in tooltip and legend" + "to represent a line. If no value was set to this option, the value" + "of dataKey will be used"
  }
}, _class2.defaultProps = {
  type: "monotone",
  stroke: _providers.DefaultThemingContext.theme.corePrimary
}, _temp)) || _class;

var _default = Line;
exports["default"] = _default;